var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfirmationStep',{attrs:{"request":_vm.request,"step":_vm.step},on:{"clicked":_vm.updateStep,"goToStep":_vm.customStep}})}
var staticRenderFns = []

export { render, staticRenderFns }